import React, { useContext } from 'react';
import { Outlet } from 'react-router';
import { PageContext } from '@axiom/ui';

import { EngagementAuthRouter } from '../routes/EngagementAuthRouter';

export const EngagementPage = () => {
  const { setTitle } = useContext(PageContext);
  setTitle('AxiomLaw - Engagements');
  return (
    <EngagementAuthRouter>
      <div data-test="PUBLIC_ENGAGEMENT">
        <Outlet />
      </div>
    </EngagementAuthRouter>
  );
};
